import api from "@/api/laravelApi";

export const getTitularesInfo = async () => {
  // Esta acción es necesaria como placeholder para evitar errores de Vuex en el componente.
  return { ok: true };
};

export const getTitulares = async ({ commit }, { flag = 1, page = 1, per_page = 10, nombre = null } = {}) => {
  try {
    const { data: info } = await api.get(`/superAdmin/listarUsuarios/${flag}`, {
      params: { page, per_page, nombre }
    });

    const { status, data: result, message } = info;

    if (status != "success") return { ok: false, message };

    // El arreglo de datos suele estar en result.data si es paginado, o result si es simple
    const list = result.data || result;
    const totalRecords = result.total || (result.meta ? result.meta.total : (info.total || 0));
    const pageActual = result.current_page || (result.meta ? result.meta.current_page : (info.current_page || 1));

    commit("setTitulares", {
      data: Array.isArray(list) ? list : [],
      total: totalRecords,
      current_page: pageActual,
      per_page
    });

    return { ok: true, message };
  } catch (err) {
    let msg;
    if (err.response) {
      msg = err.response.data.message;
    } else if (err.request) {
      msg = err.request;
    } else {
      msg = err.message;
    }
    return { ok: false, message: msg };
  }
};

export const getDashboard = async ({ commit }) => {
  try {
    const { data: info } = await api.get(`/superAdmin/listado`);

    const { status, data, message } = info;

    if (status != "success") return { ok: false, message };
    commit("getDashboard", { data });
    return { ok: true, message };
  } catch (err) {
    let msg;
    if (err.response) {
      msg = err.response.data.message;
    } else if (err.request) {
      msg = err.request;
    } else {
      msg = err.message;
    }
    return { ok: false, message: msg };
  }
};

export const validarCurpTitular = async (_, form) => {
  try {
    const data = await api.post(`/admin/validateCurpAdmin`, form);
    return data;
  } catch (err) {
    let msg;
    if (err.response) {
      msg = err.response.message;
    } else if (err.request) {
      msg = err.request;
    } else {
      msg = err.message;
    }
    return { ok: false, message: msg };
  }
};

export const crearNuevoTitular = async (_, form) => {
  try {
    const data = await api.post(`/auth/registroTitular`, form);
    return data;
  } catch (err) {
    // let msg;
    // if (err.response) {
    //   msg = err.response.message;
    // } else if (err.request) {
    //   msg = err.request;
    // } else {
    //   msg = err.message;
    // }
    return { ok: false, message: err };
  }
};

export const bajaAltaUsuario = async (_, form) => {
  try {
    const data = await api.post(`/superAdmin/habilitarUsuario`, form);
    return data;
  } catch (err) {
    let msg;
    if (err.response) {
      msg = err.response.message;
    } else if (err.request) {
      msg = err.request;
    } else {
      msg = err.message;
    }
    return { ok: false, message: msg };
  }
};

export const editarUsuario = async (_, form) => {
  try {
    const data = await api.post(`/superAdmin/editarUsuario`, form);
    return data;
  } catch (err) {
    let msg;
    if (err.response) {
      msg = err.response.message;
    } else if (err.request) {
      msg = err.request;
    } else {
      msg = err.message;
    }
    return { ok: false, message: msg, error: err.response };
  }
};

export const getLeyendas = async ({ commit }) => {
  try {
    const { data: info } = await api.get(`/leyenda/getAllLeyendas`);

    const { status, data, message } = info;

    if (status != "success") return { ok: false, message };
    commit("setLeyendas", { data });
    return { ok: true, message };
  } catch (err) {
    const data = err.response

    return data
  }
};

export const crearLeyenda = async (_, form) => {
  try {
    const data = await api.post(`/leyenda/createLeyenda`, form);

    return data;
  } catch (error) {
    const data = error.response

    return data
  }
};

export const editarLeyenda = async (_, form) => {
  try {
    const data = await api.post(`/leyenda/updateLeyenda`, form);

    return data;
  } catch (error) {

    const data = error.response

    return data
    // let msg;
    // if (error.response) {
    //   msg = error.response.message;
    // } else if (error.request) {
    //   msg = error.request;
    // } else {
    //   msg = error.message;
    // }
    // return { ok: false, message: msg };
  }
};

export const habilitacionLeyenda = async (_, form) => {
  try {
    const data = await api.post(`/leyenda/habilitacionLeyenda`, form);
    return data;
  } catch (error) {

    const data = error.response

    return data
  }
};

// export const validarCurpUsuario = async (_, form) => {
//   try {
//     const data = await api.post(`/admin/validateCurpAdmin`, form);
//     return data;
//   } catch (err) {
//     let msg;
//     if (err.response) {
//       msg = err.response.message;
//     } else if (err.request) {
//       msg = err.request;
//     } else {
//       msg = err.message;
//     }
//     return { ok: false, message: msg };
//   }
// };
